import LogoLink from 'src/shared/components/ui/logo-link'

export default function AuthHeaderLogo({ headerLogoLinkTo }: { headerLogoLinkTo: string }) {
  return (
    <div className="absolute left-0 top-0 flex h-[70px] w-full items-center justify-center lg:h-[min(10vh,70px)]">
      <LogoLink to={headerLogoLinkTo} showCircleR={false} logoClassName="h-[30px] w-[145px]" />
    </div>
  )
}
